import { styled, Box } from '@mui/material'
import theme from 'lib/theme'

export const SidebarLinkWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'highlighted',
})<{ highlighted: boolean }>(({ highlighted }) => ({
  height: '32px',
  padding: theme.spacing(2),
  backgroundColor: highlighted ? theme.palette.action.selected : 'transparent',
  color: highlighted
    ? theme.palette.primary.main
    : theme.palette.commonColors.black,
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: highlighted
      ? theme.palette.action.selected
      : theme.palette.action.hover,
  },
  borderRadius: '4px',
  marginBottom: theme.spacing(1),
}))
